import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=fda09b26&scoped=true&lang=pug&"
import script from "./Loader.js?vue&type=script&lang=js&"
export * from "./Loader.js?vue&type=script&lang=js&"
import style0 from "./Loader.sass?vue&type=style&index=0&id=fda09b26&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda09b26",
  null
  
)

export default component.exports